module.exports = __webpack_public_path__ + "static/img/standardPic3.617c80a3.png";